import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <span className="font-heading text-2xl text-white">风车动漫</span>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                专注动漫的在线观看平台，提供全集动漫资源，支持从开头到结局连续播放，无需等待更新，满足用户一口气看完整个系列的需求。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-white mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">首页</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-white mb-4">热门分类</h4>
              <div className="flex flex-col gap-2">
                {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-white mb-4">联系方式</h4>
              <div className="flex flex-col gap-2 text-sm text-foreground-400">
                <span>邮箱：contact@fengchedongman.com</span>
                <span>客服QQ：1234567890</span>
                <span>工作时间：周一至周五 9:00-18:00</span>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 风车动漫 FengCheDongMan. All rights reserved.
            </p>
            <p className="text-xs text-foreground-500">
              本站所有内容均来自网络，仅供学习和交流使用，版权归原作者所有。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}